export default [
  {
    path: '',
    name: 'product list',
    component: () => import('@/views/app/product/list/page-list.vue'),
    meta: { title: 'Daftar Produk' },
  },
]
